import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class StudentChecklistService {

  private _token:string = localStorage.getItem('token');
  
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  /* postAcademicInfo$(info: any): Observable<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'academicinfo/add-academic-information', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  getAcademicInfo(info: any): Observable<any>{

    let headers = new Headers({ 'Authorization': this._token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint +'academicinfo/get-academic-information', info, options)
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
    .catch((error: any) => Observable.throw(error.json().error || 'Server error')); // ...errors if any

  } */

  getQuestions() {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'studentchecklist/get-questions', options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }
  getCheckListByid(lid, pid) {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'studentchecklist/get-checklist-by-lid/'+lid, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  postStudentChecklist$(info: any): Observable<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'studentchecklist/post-student-checklist', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  addStudentChecklist$(info: any): Observable<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'studentchecklist/add-student-checklist', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  

  getStudentChecklist(info: any): Observable<any>{
    
    let headers = new Headers({ 'Authorization': this._token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint +'studentchecklist/get-student-checklist', info, options)
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
    .catch(this.handleErrorObservable); // ...errors if any

  }

  getLatestTasks() {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'studentchecklist/get-latest-tasks', options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }
  
  
  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
 
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/student-checklist.service.ts